import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';

import { api } from '@/api';
import { DeleteAction, EditAction } from '@/components/table/actions';
import { getColumnSearchFields } from '@/components/table/filters';
import { PERMISSION_DELETE, PERMISSION_OBJ_COOPERATIVE, PERMISSION_UPDATE } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { cooperativeStore } from '@/stores';
import { booleanFormatted, showError } from '@/utils/common';

const PermissionedEditAction = withPermissions([[PERMISSION_OBJ_COOPERATIVE, PERMISSION_UPDATE]])(EditAction);
const PermissionedDeleteAction = withPermissions([[PERMISSION_OBJ_COOPERATIVE, PERMISSION_DELETE]])(DeleteAction);

const Actions = (_: any, record: any) => {
  const onDelete = () => {
    api.cooperatives
      .delete(record.id)
      .source.then(() => cooperativeStore.deleteItem(record.id))
      .catch(showError);
  };

  return (
    <Space onClick={(e) => e.stopPropagation()}>
      <PermissionedEditAction uiSref={{ to: 'base-layout.cooperatives.edit', params: { cooperativeId: record.id } }} />
      <PermissionedDeleteAction onConfirm={onDelete} />
    </Space>
  );
};

export const columns = [
  {
    title: 'id',
    dataIndex: 'id',
    width: 60,
    sorter: true,
  },
  {
    title: <FormattedMessage id="counterparties.name" />,
    dataIndex: 'name',
    ...getColumnSearchFields(),
  },
  {
    title: <FormattedMessage id="counterparties.code" />,
    dataIndex: 'code',
    sorter: true,
  },
  {
    title: <FormattedMessage id="counterparties.consortium" />,
    dataIndex: 'consortiums',
    sorter: false,
    render: (_: any, record: cyrian.api.cooperatives.Cooperative) =>
      record.consortiums?.map((c) => c.name).join(', ') ?? null,
  },
  {
    title: <FormattedMessage id="cooperatives.isEudrCompliant" />,
    dataIndex: 'isEudrCompliant',
    sorter: true,
    width: 150,
    render: (_: any, record: cyrian.api.cooperatives.Cooperative) => booleanFormatted(record.isEudrCompliant),
    filters: [
      { text: <FormattedMessage id="common.yes" />, value: true },
      { text: <FormattedMessage id="common.no" />, value: false },
    ],
    filterMultiple: false,
  },
  {
    title: '',
    render: Actions,
    className: 'actions',
  },
];
